(function() {
	'use strict';

	angular.module('quantixApp').factory('localStorage', localStorage);
	localStorage.$inject = [ '$resource' ];
	function localStorage($resource) {
		return {};
	}

	angular.module('quantixApp').controller('InfrastructureProjectsDetailsController',
			InfrastructureProjectsDetailsController);

	InfrastructureProjectsDetailsController.$inject = [ '$scope', 'Principal', '$state','$stateParams','InfrastructureProjectsService',
		'GenericServiceNew', 'ivhTreeviewBfs', '$timeout', 'ivhTreeviewOptions', 'ErrorHandlerService', '$uibModal', '$http' ,'$window','$rootScope','GenericService'];

	function InfrastructureProjectsDetailsController($scope, Principal, $state,$stateParams, InfrastructureProjectsService,
			GenericServiceNew, ivhTreeviewBfs, $timeout, ivhTreeviewOptions, ErrorHandlerService, $uibModal, $http,$window,$rootScope,GenericService) {
		
		var gridData='';
		
		var vm = this;
		vm.modelName = $stateParams.modelName;
		vm.data = $stateParams.data;
		$scope.selectedFilter=$stateParams.selectedFilter;
		$scope.modal = {
			selectedHolding : "",
			selectedSpv : ""
		}
		$scope.isFinancialEligible = false;
		$scope.userSectionAccessData = GenericService.getUserSectionAccessData();
		
/*		$scope.addORremoveFlag = false;*/
		
		
		$scope.exportflag='';
		//$scope.previousRatingText='';
		
		$scope.modelNameKey = vm.modelName;
		
		if(vm.data ==  null){
			$state.go('infrastructureProjects');
		}
		
		$scope.flag='';
		$scope.exportFlag = false;

		GenericService.getUserModuleAccessData().then(function(result){
			GenericService.getUserSectionAccessData().then(function (result) {
                $scope.userSectionAccessData = result;
				if (!(($scope.userSectionAccessData["INFRASTRUCTURE.Roads"] == "Y") || ($scope.userSectionAccessData["INFRASTRUCTURE.Roads_Trial"] == "Y"))) {
					ErrorHandlerService.forbiddenError("Roads & Highways");
					return;
				}
				if ($scope.userSectionAccessData["INFRASTRUCTURE.Roads"] == "Y") {
					$scope.exportFlag = true;
				}
            });
			if (!result["INFRASTRUCTURE"]) {
				ErrorHandlerService.forbiddenError("INFRASTRUCTURE");
				return;
			}
		});
		
	
/*		$scope.gridDataForAll = {
					dataProvider : vm.data,
					delegate : $scope
				};
		
		
	 	   $scope.gridDataForAllCompletion = function (event) {
	   		  gridData = event.target;
	   		  gridData.validateNow();
	        };*/
		
$scope.gridDataForBotToll = {
				dataProvider : vm.data,
				delegate : $scope
			};

$scope.gridDataForBotToll1 = {
		dataProvider : vm.data,
		delegate : $scope
	};

	$scope.gridDataForHam ={
			dataProvider : vm.data,
			delegate : $scope
			
	};
	$scope.gridDataForHam1 ={
			dataProvider : vm.data,
			delegate : $scope
			
	};
	
	$scope.gridDataForBotAnnuity ={
			dataProvider : vm.data,
			delegate : $scope
			
	};
	
	$scope.gridDataForBotAnnuity1 ={
			dataProvider : vm.data,
			delegate : $scope
			
	};
	
	$scope.gridDataNHIDCL={
			dataProvider :vm.data,
			delegate : $scope
			
	};
	$scope.gridDataNHIDCL1={
		dataProvider :vm.data,
		delegate : $scope
	};
	
	$scope.gridDataPMGSY={
			dataProvider : vm.data,
			delegate : $scope
			
	};
	
	$scope.gridDataNHAI={
			dataProvider : vm.data,
			delegate : $scope
			
	};
	
	$scope.gridDataNHAI1={
			dataProvider : vm.data,
			delegate : $scope
			
	};
	
	$scope.botTollListGridCompletion = function(event) {
		gridData = event.target;
		gridData.validateNow();
		$("#gridForBotToll_btnSettings img").attr('title','Select columns');
		$("#gridForBotToll_btnSettings img").attr('title','Select columns');
		$("#gridForBotToll1_btnSettings img").attr('title','Select columns');
		$("#gridForBotToll1_btnSettings img").attr('title','Select columns');
	};

	$scope.hamListGridCompletion = function(event) {
		gridData = event.target;
		gridData.validateNow();
		$("#gridForHam_btnSettings img").attr('title','Select columns');
		$("#gridForHam_btnSettings img").attr('title','Select columns');
		$("#gridForHam1_btnSettings img").attr('title','Select columns');
		$("#gridForHam1_btnSettings img").attr('title','Select columns');
	};

	$scope.botAnnuityListGridCompletion = function(event) {
		gridData = event.target;
		gridData.validateNow();
		$("#gridForBotAnnuity_btnSettings img").attr('title','Select columns');
		$("#gridForBotAnnuity_btnSettings img").attr('title','Select columns');
		$("#gridForBotAnnuity1_btnSettings img").attr('title','Select columns');
		$("#gridForBotAnnuity1_btnSettings img").attr('title','Select columns');
	};

	$scope.nhidclListGridCompletion = function(event) {
		gridData = event.target;
		gridData.validateNow();
		$("#gridForNHIDCL_btnSettings img").attr('title','Select columns');
		$("#gridForNHIDCL_btnSettings img").attr('title','Select columns');
		$("#gridForNHIDCL1_btnSettings img").attr('title','Select columns');
		$("#gridForNHIDCL1_btnSettings img").attr('title','Select columns');
	};

	$scope.pmgsyListGridCompletion = function(event) {
		gridData = event.target;
		gridData.validateNow();
		$("#gridForPMGSY_btnSettings img").attr('title','Select columns');
		$("#gridForPMGSY_btnSettings img").attr('title','Select columns');
	};
	
	$scope.nhaiListGridCompletion = function(event) {
		gridData = event.target;
		gridData.validateNow();
		$("#gridForNHAI_btnSettings img").attr('title','Select columns');
		$("#gridForNHAI1_btnSettings img").attr('title','Select columns');
	};   
	$scope.showFinancials = function(val) {
		var arr = ['Hybrid Annuity Model', 'Build-Operate-Toll (BOT) - Annuity', 'Build-Operate-Toll (BOT) - Toll']
		if( arr.includes(val)) {
			$scope.isFinancialEligible = true;
			return true;
		}
		$scope.isFinancialEligible = false;
		return false;
	}
	$scope.selectedvalue = "";
	$scope.addFinancial = function (ele) {
		if (ele.target.type == 'radio') {
			var radioVal = $("#addFinancialId input.addFinancial:checked")
				.val();
			if ($scope.selectedvalue != radioVal) {
				$scope.selectedvalue = radioVal;
				$scope.addfincancialData();
			}
		} else {
			return false;
		}
	}

	$scope.addfincancialData = function () {
		if(!$scope.isFinancialEligible) return false;
		$scope.selectedFilter = angular.fromJson($scope.selectedFilter);
		$scope.selectedFilter.addFinancial = $scope.selectedvalue;
		InfrastructureProjectsService.getProjectDataMapForSelection(JSON.stringify($scope.selectedFilter)).then(function (data) {
			$scope.gridDataForBotToll1 = {
				dataProvider: data[Object.keys(data)[0]]['Build-Operate-Toll (BOT) - Toll'],
				delegate: $scope
			};
			$scope.gridDataForHam1 = {
				dataProvider: data[Object.keys(data)[0]]['Hybrid Annuity Model'],
				delegate: $scope

			};
			$scope.gridDataForBotAnnuity1 = {
				dataProvider: data[Object.keys(data)[0]]['Build-Operate-Toll (BOT) - Annuity'],
				delegate: $scope

			};
		}, function (errordata) {

		});
	}
	$scope.setRatingColumnHeader = function(row, column) {
		if ($scope.isFinancialEligible) {
		    if ($scope.selectedvalue == 'spv') {
		        column._headerText = "Rating for SPV";
		    } else {
		        column._headerText = "Promoter Rating";
		    }
		}
		var param = column.dataField;
		var val = row[param];
		return val;
	}

		
/*	  $scope.exportInputDTO = { competitorId : $scope.competitorId ,
			  ratingInput : $scope.inputDataTemp + "" };
		
	  
	  
		$scope.exportInputDTO = {
				portfolioId : JSON.stringify($scope.portfolioId),
				updateType : $scope.updates.updateType,
				companyScope : $scope.updates.companyScope,
				agency : $scope.agencyForUpdates,
				searchData : JSON.stringify($scope.searchTextUpDowngrades),
				analysisSearchData : $scope.analysisData,
				portfolioName : $scope.selectedPortName,
				strList : $scope.portfolioExcelList,
				asOndate : $scope.asOnDate.toString()
			};*/

	  
	  
		
/*	        $scope.selectedFilterDataWithName={
	        		
	        		selectedFilter : $scope.selectedFilter,
	        		modelNameKey :$scope.modelNameKey,
	        		addORremoveFlag:$scope.addORremoveFlag
	        		
	        		
	        };
		
		
		
	 		$scope.downloadDataInExcelDetails = function(){
				$http({
					url : 'api/infrastructureProjects/exportExcelInfraDataDetails',
					method : 'POST',
					data : $scope.selectedFilterDataWithName,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {
								
									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'Infrastructure Project Report.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'Infrastructure Project Report.xlsx'
										})[0].click();

										anchor.remove();

									}

								})
				

			
				
			
	 			
	 			
	 		}*/
	 		
	 		
			$scope.getCompanyData = function(row, column) {

				$scope.flag ='CREDIT';
				
				if(row.companyCode!=null){
					return ( ' <a onClick= "searchCompany(this, \''
							+ row.companyCode  + '\', \'' + row.contractorName + '\', \''
							+ $scope.flag + '\')"> <b>'
							+ row.contractorName + ' </b> </a> ');
				}
				return ('<div><b>' + row.contractorName + '</b></div>');;
					
					
				}
			
			
			
			$window.searchCompany = function(object,companyCodeToview, companyName,
					companyFlag) {
				if (companyCodeToview != "") {
					
					if (companyFlag == 'SME' || companyFlag == 'NSIC') {
						var paramsValue = {
								'companyCode' : companyCodeToview,
								'flag' : companyFlag
							};
						var url = $state.href('smeDetails');
						$window.localStorage['companyCodeToRedirect']=JSON
						.stringify(paramsValue);;
						$window.open(url,'_blank');
						
					} else {
						var paramsValue = {
								'companyCode' : companyCodeToview,
								'flag' :companyFlag,
								'companyName' : companyName
							};
					var url = $state.href('companyDetails');
					$window.localStorage['companyCodeToRedirect']=JSON
					.stringify(paramsValue);
					$window.open(url,'_blank');
						
						
					}
					$anchorScroll();
				}
			}
		
			
			
/*			$scope.addORremoveFlag = false;
			$scope.addORRemoveFun = function() {
				$scope.addORremoveFlag = $scope.addORremoveFlag;
			
				if ($scope.addORremoveFlag == true) {
					$scope.addORremove = 'add';
					$scope.previousRatingText = 'Remove';
					$scope.crisilCreditGridDataForAdd = {
							dataProvider : $scope.creditRatingResultList,
							delegate : $scope
						}

				} else if ($scope.addORremoveFlag == false) {
					$scope.addORremove = 'remove';
					$scope.previousRatingText = 'Add';
					$scope.addORremoveFlag = false;
					$scope.crisilCreditGridDataForRemove = {
							dataProvider : $scope.creditRatingResultList,
							delegate : $scope
						}

				}

				$scope.addORremoveFlag = !$scope.addORremoveFlag;
				
				console.log($scope.addORremove);
			}
			$scope.addORRemoveFun();*/
			
	 		
	 		
			$scope.addORremoveFlag = false;
			$scope.addORRemoveFun = function() {
				
				
				$scope.addORremoveFlag = $scope.addORremoveFlag;
			
				if ($scope.addORremoveFlag == true) {
					$scope.addORremove = 'add';
					$scope.previousRatingText = 'Remove';
					//$scope.exportflag=true;
					$("#addFinancialId div.radio-inline").removeClass("hidden");
					if ($("#addFinancialId div input[type='radio']:checked").length > 0) {
						$scope.addfincancialData();
					} else {
						$scope.selectedvalue = "spv";
						$("#addFinancialId div input[type='radio'][value='spv']").prop("checked", true);
						$scope.addfincancialData();
					}
					// $scope.gridDataForBotToll1 = {
					// 		dataProvider : vm.data,
					// 		delegate : $scope
					// 	};
					// $scope.gridDataForHam1 ={
					// 		dataProvider : vm.data,
					// 		delegate : $scope
							
					// };
					
					// $scope.gridDataForBotAnnuity1 ={
					// 		dataProvider : vm.data,
					// 		delegate : $scope
							
					// };
					
					// $scope.gridDataNHAI1={
					// 		dataProvider : vm.data,
					// 		delegate : $scope
							
					// };
					
					

				} else if ($scope.addORremoveFlag == false) {
					$scope.addORremove = 'remove';
					$scope.previousRatingText = 'Add';
					$scope.addORremoveFlag = false;
					//$scope.exportflag=false;
					$("#addFinancialId div.radio-inline").addClass("hidden");
				}


				$scope.addORremoveFlag = !$scope.addORremoveFlag;
				
				
				  $scope.selectedFilterDataWithName={
				        	
			        		selectedFilter : $scope.selectedFilter,
			        		modelNameKey :$scope.modelNameKey,
			        		addORremoveFlag:$scope.addORremoveFlag
		        		
			        };

			}
			$scope.addORRemoveFun();
			
	      
		
		
		
	 		$scope.downloadDataInExcelDetails = function(){

				$http({
					url : 'api/infrastructureProjects/exportExcelInfraDataDetails',
					method : 'POST',
					data : $scope.selectedFilterDataWithName,
					responseType : 'arraybuffer'
				})
						.success(

								function(response) {
								
									var isIE = false || !!document.documentMode;
									$scope.response = response;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});
									if (isIE) {

										window.navigator.msSaveOrOpenBlob(blob,
												'Infrastructure Project Report.xlsx');
									} else {

										var anchor = angular.element('<a/>');
										var blob = new Blob([ response ], {
											type : 'application/vnd.ms-excel'
										})
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to document
										anchor.attr({
											href : objectUrl,
											target : '_self',

											download : 'Infrastructure Project Report.xlsx'
										})[0].click();

										anchor.remove();

									}

								})
				

							}
			
			
			
			
			

	 		$scope.gotolandingpage=function(){

	 			$state.go('infrastructureProjects');
	 		}
		
	}

})();
